import notEmpty from '@/lib/helpers/not-empty';

const isOptionalAcceptedValue = (field, value) => field.isOptional && !notEmpty(value);

export default isOptionalAcceptedValue;
